import styled from "@emotion/styled";
import {flex} from "@pg-design/helpers-css";

export const StyledIconWrapper = styled.div`
    ${flex("center", "center")};
    width: var(--mobile-header-height);
    height: 100%;
    border-radius: 50%;
`;
